import dayjs from 'dayjs';

// Svenska månadsnamn (dayjs-locale-oberoende).
export const SVENSKA_MÅNADER = [
    'januari', 'februari', 'mars', 'april', 'maj', 'juni',
    'juli', 'augusti', 'september', 'oktober', 'november', 'december',
];

/** Formaterar en momsperiod som "År månad-månad", t.ex. "2024 april-juni" (eller "2024 mars" för en enskild månad). */
export function formatMomsperiod(period?: { förstaDag?: string; sistaDag?: string }): string {
    const start = period?.förstaDag ? dayjs(period.förstaDag) : null;
    if (!start || !start.isValid()) return 'Momsperiod';
    const slutRaw = period?.sistaDag ? dayjs(period.sistaDag) : null;
    const slut = slutRaw && slutRaw.isValid() ? slutRaw : start;

    if (start.year() === slut.year()) {
        if (start.month() === slut.month()) return `${start.year()} ${SVENSKA_MÅNADER[start.month()]}`;
        return `${start.year()} ${SVENSKA_MÅNADER[start.month()]}-${SVENSKA_MÅNADER[slut.month()]}`;
    }
    return `${SVENSKA_MÅNADER[start.month()]} ${start.year()}-${SVENSKA_MÅNADER[slut.month()]} ${slut.year()}`;
}
